import React from "react";
import FieldBase from "../../../../../../../../common/components/forms/fieldBase";
import * as Yup from "yup";
import {
  REQUIRED,
  TOO_LONG,
  TOO_SHORT
} from "../../../../../../../../constants/dictionary/validation";

const FIELD_NAME = "note";

export const YUP_NOTE = Yup.string()
  .min(2, TOO_SHORT)
  .max(100, TOO_LONG);

export const YUP_NOTE_REQUIRED = YUP_NOTE.required(REQUIRED);

const NoteField = ({ baseParams, index }) => {
  return (
    <FieldBase
      name={`categories.${index}.${FIELD_NAME}`}
      label="Poznámka kategorie"
      fullWidth={true}
      type="text"
      placeholder="Zde vložte poznámku kategorie"
      baseParams={baseParams}
    />
  );
};

export default NoteField;
